var _path, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 15 17 10"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2b1e100f03d1cbeb777df6ca635bb431.svg";
export { ForwardRef as ReactComponent };